module.exports = __webpack_public_path__ + "img/login_taoyu.6a2d525c.jpg";